<div class="page-header-container">
    <div class="page-title">
        {{'asset.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <div class="custom-text-input-wrap">
            <kendo-textbox
                #assetSearch
                type="text"
                [clearButton]='true'
                placeholder="{{'contracts.filterModal.assetFilterPlaceholder' | translate }}"
                [(ngModel)]="pageFilter.searchText"
                (valueChange)="searchQuery$.next($event)">
            </kendo-textbox>
        </div>
    </div>

    <button class="btn white-btn text-uppercase" (click)="toggleAssetsListByContractState()">
        <span>
            {{ 'asset.' + (pageFilter.activeContracts ? 'closedContractsAssets' : 'activeContractsAssets') | translate | uppercase }}
        </span>
    </button>

    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="contractHandler()">
        {{'asset.contractFilter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="contractHandler()">
                <span>{{'asset.contractFilterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>

    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData && !loading">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<asset-list-view *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp)" 
    [orderedAssets]="orderedAssets"
    [allAssets]="assets"
    [props]="props" 
    [activeContracts]="showActiveContracts"
    [requestAccessWarnings]="warningMessages"
    [navigateToDetailHandler]="navigateToDetailHandler"
></asset-list-view>
<asset-card-view *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp)" 
    [orderedAssets]="orderedAssets"
    [assets]="assets"
    [props]="props"
    [activeContracts]="showActiveContracts"
    [requestAccessWarnings]="warningMessages"
    [navigateToDetailHandler]="navigateToDetailHandler"
></asset-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
